import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@components/common/table";
import useTranslator from "@pma/hooks/use-translator";
import * as XLSX from "xlsx";
import { toast } from "@pma/hooks/use-toast";
import { DictType } from "@pma/types";
interface Props {
  file: DictType;
}

const ExcelFileViewer = ({ file }: Props) => {
  const [sheetData, setSheetData] = useState<any[]>([]);
  const [excelColumns, setExcelColumns] = useState<string[]>([]);

  const { translate } = useTranslator();

  const formatExcelData = () => {
    return fetch(file?.file)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onload = (evt) => {
          const bstr = evt.target?.result;

          try {
            const workbook = XLSX.read(bstr, { type: "array" });
            const ws = workbook.Sheets[workbook.SheetNames[0]];
            const data = XLSX.utils.sheet_to_json(ws, { defval: "" });

            if (data.length > 0) {
              const cols = Object.keys(data[0] as object).filter(
                (col: any) => col !== null && col !== "",
              );

              setExcelColumns(cols);
              setSheetData(data);
            }
          } catch (error: any) {
            toast({
              title: translate("Error"),
              description: translate(error?.message),
              variant: "error",
            });

            return error;
          }
        };
        reader.readAsArrayBuffer(blob);
      });
  };

  useEffect(() => {
    formatExcelData();
  }, []);

  return (
    <div className='w-[80vw] max-h-[70vh] min-h-[100px] h-full overflow-auto rounded'>
      <Table className='border-collapse text-sm '>
        <TableHeader className='bg-primary/40'>
          <TableRow>
            {excelColumns.map((col, index) => (
              <TableHead key={col} className='border px-2 h-8'>
                {col.includes(`__EMPTY`) ? translate("") + ` ${index + 1}` : col}
              </TableHead>
            ))}
          </TableRow>
        </TableHeader>
        <TableBody>
          {sheetData.map((row, i) => (
            <TableRow key={i}>
              {excelColumns.map((col) => (
                <TableCell key={col} className='border px-2 py-1'>
                  {row[col]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
};

export default ExcelFileViewer;
